import styles from './StartVisitDialog.module.scss';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import moment, { Moment } from 'moment-timezone';

import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from '@fluentui/react';

import BlockUi from 'react-block-ui';
import { HealAPI } from '../../../healApi';
import { ToastParams } from '../../../redux/message/types';
import { Visit } from '../../../redux/visits/types';
import { DateTimePicker } from '../../core/DateTimePicker';

export interface StartVisitDialogProps {
  visit: Visit;
  onClosed?: (success: boolean) => void;
  actions: {
    toast: (params: ToastParams) => void;
  };
}

export interface StartVisitDialogState {
  isSaving: boolean;
  datetime: Moment;
}

export class StartVisitDialog {
  public static show(options: StartVisitDialogProps) {
    const dialogNode = document.createElement('div');
    const close = (): void => {
      ReactDOM.unmountComponentAtNode(dialogNode);
      dialogNode.remove();
    };
    ReactDOM.render(<StartVisitDialogInternal {...options} close={close} />, dialogNode);
  }
}

class StartVisitDialogInternal extends React.Component<StartVisitDialogProps & { close: () => void }, StartVisitDialogState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isSaving: false,
      datetime: moment(),
    };
  }

  public render(): JSX.Element {
    return (
      <Dialog
        hidden={false}
        modalProps={{
          className: styles.startVisitDialog,
          isBlocking: true,
        }}
        dialogContentProps={{
          type: DialogType.largeHeader,
          title: 'Start visit: ' + this.props.visit.visitCode,
          subText: `Timezone: ${this.props.visit.timezone}`,
        }}
        onDismiss={() => this.close()}
      >
        <BlockUi tag="div" blocking={this.state.isSaving}>
          <DateTimePicker label="Set the start time" required={true} value={this.state.datetime} onChange={(m) => this.setState({ datetime: m })} />

          <DialogFooter>
            <PrimaryButton onClick={this.onStart} disabled={this.state.isSaving}>
              Ok
            </PrimaryButton>
            <DefaultButton onClick={() => this.close()} disabled={this.state.isSaving}>
              Cancel
            </DefaultButton>
          </DialogFooter>
        </BlockUi>
      </Dialog>
    );
  }

  private close = (success = false) => {
    if (this.props.onClosed) {
      this.props.onClosed(success);
    }
    this.props.close();
  };

  private onStart = () => {
    this.setState({ isSaving: true });
    HealAPI.startVisit(this.props.visit.visitCode, this.state.datetime.toDate()).then((response) => {
      this.setState({ isSaving: false });
      if (response.ok) {
        this.close(true);
      }
    });
  };
}
